import {
  Plugins,
} from "@capacitor/core";

const { Storage } = Plugins;

const CapacitorStorage = {
  getItem: (key: string): Promise<string> => {
    return new Promise((resolve) => {
      Storage.get({ key }).then(value => {
        if (value.value) {
          resolve(value.value);
        } else {
          resolve("");
        }
      })
    })
  },
  setItem: (key: string, value: string): Promise<void> => {
    return Storage.set({ key, value });
  },
  removeItem: (key: string): Promise<void> => {
    return Storage.remove({ key });
  },
}

export default CapacitorStorage